export const GET_FACILITIES_SUCCESS = 'GET_FACILITIES_SUCCESS';
export const GET_FACTS_SUCCESS = 'GET_FACTS_SUCCESS';
export const GET_SECTIONS_SUCCESS = 'GET_SECTIONS_SUCCESS';
export const GET_PACKAGES_SUCCESS = 'GET_PACKAGES_SUCCESS';
export const GET_VOLUNTEERING_SUCCESS = 'GET_VOLUNTEERING_SUCCESS';
